import type { QueryFunctionContext } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";

import type { Journal } from "../../../lib";
import { allJournalSchema, journalSchema } from "../../../lib";
import { useRequestInfiniteQuery, useRequestMutation } from "../../../request";
import { keyJournals } from "./keyJournals";

export const useRequestJournals = () => {
  const queryClient = useQueryClient();
  return {
    mutationPost: useRequestMutation<
      typeof journalSchema,
      { journal: Journal }
    >({
      mutationFnRequestProps: ({ journal }) => ({
        method: "POST",
        urlBackendPath: "/journals",
        schema: journalSchema,
        body: JSON.stringify(journal),
      }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: keyJournals() });
      },
    }),
    infiniteQuery: useRequestInfiniteQuery({
      queryFnRequestProps: ({
        pageParam,
      }: QueryFunctionContext<any, string>) => ({
        urlBackendPath: `/journals${!!pageParam.length ? `?last_id=${pageParam}` : ""}`,
        schema: allJournalSchema,
      }),
      enabledWithoutSessionToken: false,
      queryKey: keyJournals(),
      initialPageParam: "",
      getNextPageParam: (lastPage) =>
        lastPage?.length ? lastPage[lastPage.length - 1].id.toString() : null,
    }),
  };
};
